import { Section, SectionCard, SectionHeader } from '@/components/common';
import { FeedbackItemList } from './FeedbackItemList';
import {
  useUpdateStrengthFeedbacks,
  useUpdateDevelopmentAreaFeedbacks,
} from '@/queries/useJobEnds';
import type {
  StrengthFeedback,
  DevelopmentAreaFeedback,
  FeedbackItemRequest,
} from '@/api/types/jobEnd.types';

interface StrengthsDevelopmentSectionProps {
  strengths: StrengthFeedback[];
  developmentAreas: DevelopmentAreaFeedback[];
  canEdit: boolean;
  jobEndId: number;
  error?: boolean;
  rowVersion?: string;
}

export function StrengthsDevelopmentSection({
  strengths,
  developmentAreas,
  canEdit,
  jobEndId,
  error,
  rowVersion,
}: StrengthsDevelopmentSectionProps) {
  const { mutate: updateStrengths } = useUpdateStrengthFeedbacks();
  const { mutate: updateDevelopmentAreas } = useUpdateDevelopmentAreaFeedbacks();

  const handleSaveStrengths = (items: FeedbackItemRequest[]) => {
    updateStrengths({ id: jobEndId, items, rowVersion });
  };

  const handleSaveDevelopmentAreas = (items: FeedbackItemRequest[]) => {
    updateDevelopmentAreas({ id: jobEndId, items, rowVersion });
  };

  return (
    <Section>
      <SectionHeader error={error}>FEEDBACK</SectionHeader>
      <SectionCard>
        <FeedbackItemList
          title="STRENGTHS"
          items={strengths}
          canEdit={canEdit}
          onSave={handleSaveStrengths}
          addButtonLabel="ADD STRENGTH"
          placeholder="Add a strength with evidence..."
          error={error}
        />

        <FeedbackItemList
          title="DEVELOPMENT AREAS / EVEN BETTER IFS"
          items={developmentAreas}
          canEdit={canEdit}
          onSave={handleSaveDevelopmentAreas}
          addButtonLabel="ADD DEVELOPMENT AREA"
          placeholder="Add a development area with context..."
          error={error}
        />
      </SectionCard>
    </Section>
  );
}

export default StrengthsDevelopmentSection;
